import setFooterMenu from './components/footer-menu';
import setHeaderMenu from './components/header-menu';
import { initLenis } from './components/lenis-scroll';
import { initAnalytics } from './helpers/analytics';
import setClampText from './helpers/clamp-text';
import { initLazyImages } from './helpers/lazy-images';
import { initLazyVideos } from './helpers/lazy-videos';
import { tippyHelper } from './helpers/tippyHelper';
import { initMdaGsap } from './mda-gsap';

var documentReady = function () {
    setHeaderMenu();
    setFooterMenu();
    tippyHelper();
    setClampText();
    initLazyImages();
    initLazyVideos();
    initLenis();
    initMdaGsap();
    initAnalytics();
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
    documentReady();
} else {
    document.addEventListener('DOMContentLoaded', documentReady);
}
